import { render } from "./GestionBloqueos.vue?vue&type=template&id=7cb8e388"
import script from "./GestionBloqueos.vue?vue&type=script&lang=js"
export * from "./GestionBloqueos.vue?vue&type=script&lang=js"

import "./GestionBloqueos.vue?vue&type=style&index=0&id=7cb8e388&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__